import styled, { createGlobalStyle } from "styled-components";

import { up, down, colors, fonts, spacings } from "~/src/config/vars";

import lines from "~/src/images/lines.svg";
import lines_mobile from "~/src/images/lines_mobile.svg";
import background_mask from "~/src/images/background_mask.png";

const GlobalStyle = createGlobalStyle`
    * {
        box-sizing: border-box;
        outline: none !important;
    }
    body {
        font-family: ${fonts?.ff_base};
        color: ${colors?.typo_primary};
        background-color: ${colors?.bg_body};
        line-height: 1.4;
        overflow-y: scroll;
        font-size: 16px;
        font-weight: ${fonts?.fw_regular};

        background-image: url(${lines});
        ${down("sm")} {
            background-image: url(${lines_mobile});
        }
        background-size: 120%;
        background-attachment: fixed;
        ${up("xga")} {
            font-size: 17px;
        }
    }
    input:focus {
        outline: none !important;
    }
    a {
        text-decoration: none;
        transition: color ${global?.transition};
        cursor: pointer;
        color: ${colors?.typo_link};
        @media (hover) {
            &:hover {
                color: ${colors?.typo_link_hover};
            }
        }
        &.active {
            cursor: default;
        }
    }
    svg {
        display: block;
    }
    /* [data-gatsby-image-wrapper] {
        pointer-events: none;
    } */
    .bg {
        &:after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 0;
            pointer-events: none;
            mask: url(${background_mask}) repeat 0 0/50vw 30vw;
            z-index: 0;
        }
    }
`;

export const SOffsetStyle = styled.div`
    &.top-120 {
        padding-top: ${spacings?.offset_120};
    }
    &.bottom-120 {
        padding-bottom: ${spacings?.offset_120};
    }
    &.top-80 {
        padding-top: ${spacings?.offset_80};
    }
    &.bottom-80 {
        padding-bottom: ${spacings?.offset_80};
    }
    &.top-40 {
        padding-top: ${spacings?.offset_40};
    }
    &.bottom-40 {
        padding-bottom: ${spacings?.offset_40};
    }
    &.top-20 {
        padding-top: ${spacings?.offset_20};
    }
    &.bottom-20 {
        padding-bottom: ${spacings?.offset_20};
    }
    &.top-10 {
        padding-top: ${spacings?.offset_10};
    }
    &.bottom-10 {
        padding-bottom: ${spacings?.offset_10};
    }
    &.top-0 {
        padding-top: 0;
    }
    &.bottom-0 {
        padding-bottom: 0;
    }
`;

export default GlobalStyle;
